import { dealDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique } from '../techniques.type';
import type { Player } from '../player.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const horn: Technique[] = [
  {
    ingredients: [DieFace.Horn],
    title: 'Bunt',
    text: 'Deal 1 Damage.',
    tags: ['damage'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 1, target, source, dice });
    },
  },
  {
    ingredients: [DieFace.Horn, DieFace.Horn],
    title: 'Ram',
    text: 'Deal 2 Damage, Apply 1 Wound.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Wound, 1);
    },
  },
  {
    ingredients: [DieFace.Horn, DieFace.Horn, DieFace.Horn],
    title: 'Gore',
    text: 'Deal 4 damage, Apply 2 Wound.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 4, target, source, dice });
      addModifier(target, StatusEffect.Wound, 2);
    },
  },
  {
    ingredients: [DieFace.Horn, DieFace.Hoof],
    title: 'Bull Rush',
    text: 'Deal 6 damage, Gain 1 stunned.',
    tags: ['damage', 'suffer'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 6, target, source, dice });
      addModifier(source, StatusEffect.Stunned, 1);
    },
  },
];
